module.exports = "/cyber/_next/static/images/top20-b8ad844484ca138d392feee37aca74e2.jpg";